import { CSSProperties, useMemo } from 'react';
import classNames from "classnames";
import { DCUIContentHeader, DCUIThemeHeader } from "@iddataweb/idw-common-ui/types";
import { DCUIThemingLogoContainer } from '../dcui-theming-logo-container/dcui-theming-logo-container';
import styles from "./dcui-theming-header-container.less";

type DCUIThemingHeaderContainerProps = {
    headerTheme: DCUIThemeHeader;
    headerContent: DCUIContentHeader;
    headerLogoUrl: string;
};

export const DCUIThemingHeaderContainer = (props: DCUIThemingHeaderContainerProps) => {
    const { headerTheme, headerContent, headerLogoUrl } = props; 

    const logoElement = useMemo(() => {
        if (headerTheme.showLogo && headerLogoUrl) {
            return (
                <DCUIThemingLogoContainer
                    logoUrl={headerLogoUrl}
                    altText={`Logo`}
                    alignLogo={headerTheme.alignLogo}
                    section={"header"}
                />
            );
        }
        return null;
    }, [headerTheme.showLogo, headerLogoUrl, headerTheme.alignLogo]);

    const titleElement = useMemo(() => {
        if (headerTheme.showText && headerContent.text) {
            return (
                <div className={styles.title}>
                    <h3>{headerContent.text}</h3>
                </div>
            );
        }
        return null;
    }, [headerTheme.showText, headerContent.text]);

    const headerTextColor = headerTheme.textColor;
    const headerBGColor = headerTheme.backgroundColor;

    const headerStyle: CSSProperties = {
        color: headerTextColor,
        backgroundColor: headerBGColor
    };

    const { showText, showLogo, alignText, alignLogo } = headerTheme;

    const headerContentAutoMinMax = (
        showText &&
        showLogo &&
        alignText === alignLogo
    ) ? styles.autoMinMax : "";

    return (
        <div id="header-container" className={styles.dcuiThemingHeaderContainer} style={headerStyle}>
            {(!showText && !showLogo && (
                <div id="header-content" className={styles.headerFill}></div>
            ))}
            {(showText || showLogo) && (
                <div id="header-content" className={classNames(styles.headerContent, headerContentAutoMinMax)}>
                    <div id="header-left-section" className={styles.leftHeaderSection}>
                        {showLogo && alignLogo === "left" && (
                            logoElement
                        )}
                        {showText && alignText === "left" && (
                            titleElement
                        )}
                    </div>
                    <div id="header-center-section" className={styles.centerHeaderSection}>
                        {(showLogo && alignLogo === "center") && (
                            logoElement
                        )}
                        {showText && alignText === "center" && (
                            titleElement
                        )}
                    </div>
                    <div id="header-right-section" className={styles.rightHeaderSection}>
                        {showLogo && alignLogo === "right" && (
                            logoElement
                        )}
                        {showText && alignText === "right" && (
                            titleElement
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
